document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-menu-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var nav = document.querySelector('[data-main-nav]');
      if(nav) nav.classList.toggle('is-open');
    });
  });

  document.querySelectorAll('[data-hero-slider]').forEach(function(slider){
    var track = slider.querySelector('.hero-slider__track');
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-slide-dot]'));
    var slides = slider.querySelectorAll('.hero-slide');
    if(!track || slides.length <= 1) return;

    var index = 0;
    var autoplay = slider.dataset.autoplay === 'true';
    var interval = parseInt(slider.dataset.interval || '4500', 10);

    function goTo(i){
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      dots.forEach(function(dot, n){ dot.classList.toggle('is-active', n === index); });
    }

    dots.forEach(function(dot, n){
      dot.addEventListener('click', function(){ goTo(n); });
    });

    if(autoplay){
      setInterval(function(){ goTo(index + 1); }, interval);
    }
  });
});
